import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import HeaderFunctions from "../HeaderFunctions/HeaderFunctions";
import Sidebar from "./sidebar";

const Loader = () => (
  <div className="spinner-border text-primary" role="status">
    <span className="visually-hidden">Loading...</span>
  </div>
);

const DataMigration = () => {
  const navigate = useNavigate();
  const { loading, loadingoverview, loadingig, loadingusermaser, loadingcustomerlist, loadingprojectlist, loadingrolelist, loadingscopelist, handleLogout, handleOverviewClick, handleIGClick, handleUserMaster, handleCustomerList, handleProjectList, handleRoleList, handleScopeList } = HeaderFunctions();
  const [formData, setFormData] = useState({
    customer: "",
    source: "",
    target: "",
    system_type: "",
    data_type: "",
    file_type: "",
    file: null,
  });
  const [errors, setErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  const userSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
    try {
      const token = localStorage.getItem("token");
      // const response = await axios.post(
      //   "http://localhost/ifhirehealth.clindcast.com/public/api/storeuser",
      //   formData,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       Accept: "application/json",
      //       "Content-Type": "application/x-www-form-urlencoded",
      //     },
      //   }
      // );
      setFormData({
        customer: "",
        source: "",
        target: "",
        system_type: "",
        data_type: "",
        file_type: "",
        file: null,
      });
      // navigate("/user-master", { state: { UserFormData: response.data.message } });
      setTimeout(() => {
      }, 100);
    } catch (error) {
      console.error("Failed to store data:", error.message);
    }
} else {
    setErrors(validationErrors);
  }
  };
  const validateForm = () => {
    const errors = {};
    if (!formData.customer.trim()) {
      errors.customer = 'customer is required';
    }
    if (!formData.source.trim()) {
      errors.source = 'Source is required';
    }
    if (!formData.target) {
      errors.target = 'Target is required';
    }
    if (!formData.system_type_type) {
      errors.system_type_type = 'System Type is required';
    }
    if (!formData.data_type) {
      errors.data_type = 'Data Type is required';
    }
    if (!formData.file_type) {
      errors.file_type = 'File Type is required';
    }
    return errors;
  };
  const handleCancel = () => {
    setFormData({
      customer: "",
      source: "",
      target: "",
      system_type: "",
      data_type: "",
      file_type: "",
      file: null,
    });
  };

  return (
    <>
      <Header loading={loading} loadingoverview={loadingoverview} loadingig={loadingig} loadingusermaser={loadingusermaser} loadingcustomerlist={loadingcustomerlist} loadingprojectlist={loadingprojectlist} loadingrolelist={loadingrolelist} loadingscopelist={loadingscopelist} handleLogout={handleLogout} handleOverviewClick={handleOverviewClick} handleIGClick={handleIGClick} handleUserMaster={handleUserMaster} handleCustomerList={handleCustomerList} handleProjectList={handleProjectList} handleRoleList={handleRoleList} handleScopeList={handleScopeList} />

      <div className="container">
        <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page"></li>
          </ol>
        </nav>
      </div>

      <div className="container pb-4">
        <div className="box-bdr-dash">
          <div className="row">
          <Sidebar/>
            <div className="col-md-10">
              <div className="box mb-2 form-box">
                <div className="box-top-title fhir-title">
                  <span className="pd-overview-count">Data System Master</span>
                </div>
                <div className="ig-forms">
                  <form onSubmit={userSubmit}>
                    <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="customer" className="form-label">
                            Customer <span className="text-danger fs-6">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.customer && "is-invalid"
                            }`}
                            id="customer"
                            name="customer"
                            value={formData.customer}
                            onChange={handleInputChange}
                            aria-describedby="text"
                            placeholder="Customer"
                          />
                          {errors.customer && (
                            <div className="invalid-feedback">
                              {errors.customer}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="source" className="form-label">
                            Select Source Type <span className="text-danger fs-6">*</span>
                          </label>
                          <select
                            className={`form-select ${errors.source && 'is-invalid'}`}
                            id="source"
                            name="source"
                            value={formData.source}
                            onChange={handleInputChange}
                          >
                            {errors.source && <div className="invalid-feedback">{errors.source}</div>}
                            <option value="">Select</option>
                            <option value="HL7">HL7</option>
                            <option value="FHIR">FHIR</option>
                            <option value="JSON">JSON</option>
                            <option value="XML">XML</option>
                            <option value="FlatFile">Flat File</option>
                            <option value="CustomAPI">Custom API</option>
                          </select>
                          {errors.source && <div className="invalid-feedback">{errors.source}</div>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="target" className="form-label">
                            Select Target Type <span className="text-danger fs-6">*</span>
                          </label>
                          <select
                            className={`form-select ${errors.target && 'is-invalid'}`}
                            id="target"
                            name="target"
                            value={formData.target}
                            onChange={handleInputChange}
                          >
                            {errors.role && <div className="invalid-feedback">{errors.target}</div>}
                            <option value="">Select</option>
                            <option value="eCW">eClinicalWorks (eCW)</option>
                            <option value="Epic">Epic</option>
                            <option value="Cerner">Cerner</option>
                            <option value="AthenaHealth">AthenaHealth</option>
                            <option value="CustomEHR">Custom EHR</option>
                          </select>
                          {errors.target && <div className="invalid-feedback">{errors.target}</div>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="system_type" className="form-label">
                            Select System Type <span className="text-danger fs-6">*</span>
                          </label>
                          <select
                            className={`form-select ${errors.system_type && 'is-invalid'}`}
                            id="system_type"
                            name="system_type"
                            value={formData.system_type}
                            onChange={handleInputChange}
                          >
                            {errors.system_type && <div className="invalid-feedback">{errors.system_type}</div>}
                            <option value="">Select</option>
                            <option value="EMR">EMR</option>
                            <option value="EHR">EHR</option>
                            <option value="LIMS">LIMS</option>
                            <option value="Billing">Billing</option>
                            <option value="Custom">Custom</option>
                          </select>
                          {errors.system_type && <div className="invalid-feedback">{errors.system_type}</div>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="data_type" className="form-label">
                            Select Data Type in Scope<span className="text-danger fs-6">*</span>
                          </label>
                          <div className="multi-select" id="dataTypeScope">
                            <input type="checkbox" value="Demographics"/> Demographics<br/>
                            <input type="checkbox" value="Encounters"/> Encounters<br/>
                            <input type="checkbox" value="Appointments"/> Appointments<br/>
                            <input type="checkbox" value="Medications"/> Medications<br/>
                            <input type="checkbox" value="Lab Results"/> Lab Results<br/>
                            <input type="checkbox" value="Radiology Reports"/> Radiology Reports<br/>
                            <input type="checkbox" value="Billing & Claims"/> Billing & Claims<br/>
                          </div>
                          {errors.data_type && <div className="invalid-feedback">{errors.data_type}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="form-buttons">
                      <button
                        type="submit"
                        className="btn btn-primary submit-btn"
                      >
                        <i className="fa fa-check" /> Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-btn"
                        onClick={handleCancel}
                      >
                        <i className="fa fa-close" /> Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DataMigration;